"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('cart', {
            url: '/cart',
            template: require('../views/cart.html'),
            controller: 'CartController',
            controllerAs: 'cart',
            params: {
                id: { squash: true, value: null }
            },
            resolve: {
                courierServices: ['api', 'extApi', function (api, extApi) {
                        return extApi.get('/courier-services', { page: 1, per_page: 100 })
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }],
                addresses: ['api', 'extApi', function (api, extApi) {
                        return extApi.get('/delivery-addresses', { page: 1, per_page: 100 })
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }],
                cart: ['api', function (api) {
                        return api.get('/b2b/cart/')
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/cart/config/routes.js
// module id = 428
// module chunks = 0